import { SystemNotificationContext } from '@/contexts/SystemNotificationContext';
import { useContext } from 'react';

export function useSystemNotifications() {
  const context = useContext(SystemNotificationContext);

  if (!context) {
    throw new Error('useSystemNotifications must be used within a SystemNotificationProvider');
  }

  return context;
}
